"use client";

import { getProjectBySlug } from "@/lib/mdxProject";
import { useEffect, useState } from "react";

const ProjectPage = ({ params }) => {
  const { slug } = params; // Access the slug from params
  const [project, setProject] = useState(null);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const fetchedProject = await getProjectBySlug(slug);
        setProject(fetchedProject);
      } catch (error) {
        console.error("Failed to fetch project", error);
        setProject(null);
      }
    };

    if (slug) {
      fetchProject();
    }
  }, [slug]);

  if (!project) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <section
        className="relative py-16 md:py-28 lg:py-36 -mt-24"
        style={{
          backgroundImage: 'url("/images/slide1.jpg")',
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Overlay */}
        <div className="absolute inset-0 bg-black opacity-50 z-10"></div>

        {/* Content */}
        <div className="relative z-20 max-w-screen-xl mx-auto px-5">
          <div className="grid grid-cols-1 gap-3 items-center justify-between text-gray-300">
            <div>
              <h1 className="font-bold text-white text-4xl lg:text-5xl my-3">
                {project.title}
              </h1>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-screen-xl mx-auto py-10">
        <h1 className="font-bold text-4xl mb-4">{project.title}</h1>

        <img
          src={project.featuredimage}
          alt={project.title}
          className="w-full h-auto object-cover rounded-xl mb-8"
        />

        <p
          className="text-lg leading-loose text-justify"
          dangerouslySetInnerHTML={{ __html: project.content }}
        ></p>
      </section>
    </>
  );
};

export default ProjectPage;
